/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "trash-closed-inline-b0d394fe--sprite",
  "use": "trash-closed-inline-b0d394fe--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"trash-closed-inline-b0d394fe--sprite\">\n  <rect id=\"trash-closed-inline-b0d394fe--sprite_Rectangle_11399\" data-name=\"Rectangle 11399\" width=\"16\" height=\"16\" fill=\"none\" />\n  <g id=\"trash-closed-inline-b0d394fe--sprite_Group_18702\" data-name=\"Group 18702\" transform=\"translate(-8897.969 -744.969)\">\n    <g id=\"trash-closed-inline-b0d394fe--sprite_Rectangle_9954\" data-name=\"Rectangle 9954\" transform=\"translate(8897.969 744.969)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\">\n      <rect width=\"16\" height=\"16\" stroke=\"none\" />\n      <rect x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" fill=\"none\" />\n    </g>\n  </g>\n  <g id=\"trash-closed-inline-b0d394fe--sprite_Group_21146\" data-name=\"Group 21146\">\n    <path id=\"trash-closed-inline-b0d394fe--sprite_Path_4350\" data-name=\"Path 4350\" d=\"M108.05,239.853a.966.966,0,0,1-.96.97H97.01a.97.97,0,0,1,0-1.939h10.08A.966.966,0,0,1,108.05,239.853Z\" transform=\"translate(-94.05 -236.942)\" fill=\"currentColor\" />\n    <path id=\"trash-closed-inline-b0d394fe--sprite_Path_4351\" data-name=\"Path 4351\" d=\"M97.049,245.255h10.574v8.222a2.127,2.127,0,0,1-2.115,2.139H99.164a2.127,2.127,0,0,1-2.115-2.139\" transform=\"translate(-94.337 -239.675)\" fill=\"currentColor\" />\n    <path id=\"trash-closed-inline-b0d394fe--sprite_Rectangle_6880\" data-name=\"Rectangle 6880\" d=\"M1.4,0h0A1.4,1.4,0,0,1,2.8,1.4v.539a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.4A1.4,1.4,0,0,1,1.4,0Z\" transform=\"translate(6.598)\" fill=\"currentColor\" />\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
